import { COLORS } from '@/config/colors';
import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export const muiswitch: {
  defaultProps?: ComponentsProps['MuiSwitch'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiSwitch'];
  variants?: ComponentsVariants<Theme>['MuiSwitch'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        width: 60,
        height: 32,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          background: `${COLORS.primary[500]} !important`,
          height: '26px',
          width: '24px',
          borderRadius: 3,
          '&:hover': {
            background: `${COLORS.primary[600]} !important`,
          },
          padding: 0,
          margin: 3,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(29px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
              opacity: 1,
              border: 0,
              background: COLORS.grey[800],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
            background: `${COLORS.success[600]} !important`,
            '&:hover': {
              background: `${COLORS.success[700]} !important`,
            },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: 'red',
            border: '6px solid #fff',
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22,
          height: 22,
        },
        '& .MuiSwitch-track': {
          borderRadius: 5,
          backgroundColor: COLORS.grey[800],
          opacity: 1,
          transition: theme.transitions.create(['background-color'], {
            duration: 500,
          }),
        },
      };
    },
  },
};
